<template>
  <ul class="menu-list">
    <v-divider />
    <div style="color: white"></div>
    <router-link
      v-if="
        [...$store.state.powerbuyTest].includes(selectedBot.pageid) &&
        isShowMenu('welcome') &&
        ['105344925152387'].includes(selectedBot.pageid)
      "
      :to="'/' + $i18n.locale() + '/welcome'"
      :data-intro="
        $t(
          'Make a great First Impression moment for your customers by setting Welcome Message here.'
        )
      "
      data-position="right"
    >
      <li tabindex="0">
        <span>{{ $t('Welcome Message') }}</span>
      </li>
    </router-link>
    <router-link
      v-if="
        [...$store.state.powerbuyTest].includes(selectedBot.pageid) &&
        isShowMenu('conversation') &&
        ['105344925152387'].includes(selectedBot.pageid)
      "
      :to="'/' + $i18n.locale() + '/conversation'"
      :data-intro="
        $t(
          'This Conversation page is like a heart of CHATBOT, the page will collect all pattern on how Bot replies all messages.'
        )
      "
    >
      <li tabindex="0">
        <span>{{ $t('Conversation') }}</span>
      </li>
    </router-link>
    <router-link
      :to="'/' + $i18n.locale() + '/comment'"
      :data-intro="
        $t(
          'To privately chat with the one who comments on your post, this page is how you can set which comment that you want to pull directly to your inbox and how to reply on those comments'
        )
      "
    >
      <li tabindex="0">
        <span>{{ $t('Comment to Inbox') }}</span>
      </li>
    </router-link>
    <router-link
      v-if="isShowMenu('PowerbuyManagement')"
      :to="'/' + $i18n.locale() + '/PowerbuyManagement'"
      data-position="right"
    >
      <li tabindex="0" style="position: relative">
        <span>{{ $t('Management') }}</span>
      </li>
    </router-link>
    <router-link
      v-if="isShowMenu('PowerbuyFacebookPostManager')"
      :to="'/' + $i18n.locale() + '/PowerbuyFacebookPostManager'"
      data-position="right"
    >
      <li tabindex="0" style="position: relative">
        <span>{{ $t('จัดการโพสต์ Facebook') }}</span>
      </li>
    </router-link>
    <router-link
      v-if="isShowMenu('PowerbuyFacebookShearPostManager')"
      :to="'/' + $i18n.locale() + '/PowerbuyFacebookShearPostManager'"
      data-position="right"
    >
      <li tabindex="0" style="position: relative">
        <span>{{ $t('จัดการแชร์โพสต์ Facebook') }}</span>
      </li>
    </router-link>

    <router-link
      v-if="isShowMenu('PowerbuyInstagramPostManager')"
      :to="'/' + $i18n.locale() + '/PowerbuyInstagramPostManager'"
      data-position="right"
    >
      <li tabindex="0" style="position: relative">
        <span>{{ $t('จัดการโพสต์ Instagram') }}</span>
      </li>
    </router-link>
    <router-link
      v-if="isShowMenu('PowerbuyLineBroadcast')"
      :to="'/' + $i18n.locale() + '/PowerbuyLineBroadcast'"
      data-position="right"
    >
      <li tabindex="0" style="position: relative">
        <span>{{ $t('บรอดแคสต์ Line') }}</span>
      </li>
    </router-link>
    <router-link
      v-if="isShowMenu('PowerbuyBranchManagement')"
      :to="'/' + $i18n.locale() + '/powerbuy/branch-management'"
      data-position="right"
    >
      <li tabindex="0" style="position: relative">
        <span>{{ $t('shop_management') }}</span>
      </li>
    </router-link>
    <router-link
      :to="'/' + $i18n.locale() + '/template'"
      :data-intro="
        $t(
          'If you sell any product, Shop Service might be another choice to support you. You can edit and update all the selling process here inlcuding add product, payment system, tracking system, etc.'
        )
      "
    >
      <template>
        <li tabindex="0" style="position: relative">
          <span>{{ $t('Shop Service') }}</span>
        </li>
      </template>
    </router-link>
    <router-link
      v-if="isShowMenu('dashboard')"
      :to="'/' + $i18n.locale() + '/PowerbuyAnalytics'"
      :data-intro="
        $t('It is the place where you can see both analytics data; conversation and customer')
      "
    >
      <li tabindex="0">
        <span>{{ $t('analytics') }}</span>
      </li>
    </router-link>
    <router-link
      v-if="isShowMenu('AgentManagement')"
      :to="'/' + $i18n.locale() + '/agentmanagement'"
      data-position="right"
    >
      <li tabindex="0" style="position: relative">
        <span>{{ $t('Role management') }}</span>
      </li>
    </router-link>

    <router-link
      v-if="isShowMenu('training') && [...$store.state.powerbuyTest].includes(selectedBot.pageid)"
      :to="'/' + $i18n.locale() + '/training'"
      :data-intro="$t('This page is for training Bot to be smarter, and reduce default words !')"
    >
      <li tabindex="0">
        <span>{{ $t('Training') }}</span>
      </li>
    </router-link>

    <v-divider />

    <router-link
      v-if="isShowMenu('setting') && ['105344925152387'].includes(selectedBot.pageid)"
      :to="'/' + $i18n.locale() + '/setting'"
      :data-intro="
        $t(
          'On Setting Page, you can  turn On / Off Bot, remove Bot, and check your Subscription Day Remaining. But please dont remove me :('
        )
      "
    >
      <li tabindex="0">
        <span>{{ $t('Setting') }}</span>
      </li>
    </router-link>
    <li
      tabindex="0"
      @click="logout"
      :data-intro="$t('Click here, if your setting is finished or if you want to sigh out.')"
    >
      <span>{{ $t('Sign Out') }}</span>
    </li>
    <v-divider />
  </ul>
</template>

<script>
import MainMenuList from './MainMenuList.js'
export default {
  mixins: [MainMenuList],
  methods: {
    isShowMenu(menu) {
      // PowerbuyManagement
      // PowerbuyFacebookPostManager
      // PowerbuyInstagramPostManager
      // PowerbuyLineBroadcast
      // PowerbuyAnalytics
      // dashboard
      // AgentManagement
      if (this.$store.state.privilege) {
        if (this.$store.state.privilege.role == 'admin') {
          return [
            'welcome',
            'PowerbuyFacebookPostManager',
            'PowerbuyInstagramPostManager',
            'PowerbuyLineBroadcast',
            'billing',
            'conversation'
          ].includes(menu)
        } else if (this.$store.state.privilege.role == 'agency') {
          return false
        } else if (this.$store.state.privilege.role == 'superadmin' || true) return true
      } else return true
    }
  }
}
</script>

<style lang="scss">
.menu.default {
  background-color: #ff846d !important;
}
.menu {
  .avatar {
    .bot-active {
      border: 3px solid #a0e83d;
    }

    .bot-inactive {
      border: 3px solid red;
    }
  }

  ul.menu-list {
    list-style: none;
    padding: 0.5em 0;
    margin: 0;

    .router-link-active {
      li {
        background-color: rgba(255, 255, 255, 0.2);
      }
    }

    a {
      text-decoration: none;
    }
    li {
      font-size: 0.95em;
      font-weight: 300;
      background-repeat: no-repeat;
      background-position: left 15px center;
      background-size: auto 20px;
      transition: all 0.15s linear;
      padding: 1em 1em 1em 3em;
      cursor: pointer;

      &.icon-home {
        background-image: url('/static/img/assets/sidebar/home.svg');
      }

      &.icon-greeting {
        background-image: url('/static/img/assets/sidebar/greeting.svg');
      }

      &.icon-speech {
        background-image: url('/static/img/assets/sidebar/speech.svg');
      }

      &.icon-mailbox {
        background-image: url('/static/img/assets/sidebar/mailbox.svg');
      }

      &.icon-analytics {
        background-image: url('/static/img/assets/sidebar/analytics.svg');
      }

      &.icon-billing {
        background-image: url('/static/img/assets/sidebar/billing.svg');
      }

      &.icon-setting {
        background-image: url('/static/img/assets/sidebar/setting.svg');
      }
      &.icon-ticket {
        background-image: url('/static/img/assets/sidebar/ticket.svg');
      }

      &.icon-gym {
        background-image: url('/static/img/assets/sidebar/gym.svg');
      }

      &.icon-help {
        background-image: url('/static/img/assets/sidebar/help.svg');
      }

      &.icon-megaphone {
        background-image: url('/static/img/assets/sidebar/megaphone.svg');
      }
      &.icon-reward {
        background-image: url('/static/img/assets/sidebar/reward.svg');
      }

      &.icon-premium {
        background-image: url('/static/img/assets/sidebar/premium.svg');
      }

      &.icon-shop {
        background-image: url('/static/img/assets/sidebar/shop.svg');
      }

      &.icon-sign-out {
        background-image: url('/static/img/assets/sidebar/sign-out.svg');
      }

      &.icon-plugin {
        background-image: url('/static/img/assets/sidebar/plugin.svg');
      }
      &.icon-live {
        background-image: url('/static/img/assets/sidebar/live.svg');
      }
      &.icon-ticket {
        background-image: url('/static/img/assets/sidebar/technical-support.svg');
      }

      span {
        width: 100%;
        color: white;
        margin-left: 10px;
      }

      &:hover {
        background-color: rgba(0, 0, 0, 0.1);
      }
    }

    .devide {
      border-bottom: 1px solid #ff8c88;
    }
  }
}
h1,
h2,
h3,
h4,
h5,
h6 {
  color: var(--primary-color);
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/MenuList/PowerbuyMenuList.vue